import { Check } from "lucide-react";
import { Reveal, Chapter } from "../../lib/motion";
import { IMAGES } from "../../data";

const BADGES = [
  "PFAS Free",
  "FDA",
  "BPI Certified Compostable",
  "TÜV Austria OK Compost HOME / INDUSTRIAL",
  "EN 13432 Compostability (Europe)",
  "ASTM D6400 (USA)",
];

export default function About() {
  return (
    <section id="about" data-testid="about" className="py-24 md:py-32 bg-verra-base">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Chapter number="01" overline="About Verraleaf" title="A trusted supplier of eco-friendly bagasse tableware." />
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-6">
            <Reveal className="relative">
              <div className="overflow-hidden rounded-[2rem]">
                <img src={IMAGES.aboutWhite} alt="Bleached white bagasse tableware products" className="w-full h-[460px] object-cover" />
              </div>
              <div className="absolute -bottom-6 -right-4 bg-verra-green text-white rounded-2xl px-7 py-5 shadow-xl">
                <p className="font-display text-3xl">100%</p>
                <p className="text-xs uppercase tracking-widest">Sugarcane Bagasse</p>
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-6">
            <Reveal delay={0.1}>
              <p className="text-lg md:text-xl text-verra-blue/75 leading-relaxed">
                Verraleaf, a brand of <strong className="text-verra-blue">Dhananjay Eximporter</strong>, crafts premium
                bagasse tableware manufactured to international quality standards. We help food businesses and importers
                worldwide replace plastic with renewable, compostable products — without compromising on strength or
                presentation.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="overline mt-8 mb-3">Certifications &amp; Standards</p>
            </Reveal>
            <div className="flex flex-wrap gap-3">
              {BADGES.map((b, i) => (
                <Reveal key={b} delay={0.05 * i}>
                  <span className="inline-flex items-center gap-2 rounded-full border border-verra-green/20 bg-verra-light/15 px-4 py-2 text-sm font-medium text-verra-blue/80">
                    <Check className="w-3.5 h-3.5 text-verra-green" /> {b}
                  </span>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
